import { render, staticRenderFns } from "./DialogInstagramFollowCheck.vue?vue&type=template&id=3d5bc330&scoped=true"
import script from "./DialogInstagramFollowCheck.vue?vue&type=script&lang=ts"
export * from "./DialogInstagramFollowCheck.vue?vue&type=script&lang=ts"
import style0 from "./DialogInstagramFollowCheck.vue?vue&type=style&index=0&id=3d5bc330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5bc330",
  null
  
)

export default component.exports